import React ,{ useEffect ,useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";

import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom"; // Import useNavigate
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const AddHireVehicle = () => {
  useAuthRedirect();
  const navigate = useNavigate(); // Initialize navigate function
  const [branches,setbranches] = useState([]);
  const [vCode, setVcode] = useState('');
  const [vehtypes,setvehtypes] = useState([]);
  const userName = localStorage.getItem("username"); // Default branch from storage
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [formData ,setFormData] = useState({
    fld_date: "" ,branch_code: "" ,fld_vehno: "" ,fld_vcode: "" ,fld_vname: "" ,fld_vtype: "" ,fld_vbasis: "" ,fld_vcompanyname : "",
    fld_ownersname: "" ,fld_vprice: "" ,fld_contactperson: "" ,fld_address1: "" ,fld_address2: "" ,fld_city: "" ,fld_phone: "" ,
    fld_vehappperiod: "" ,fld_fcexpire: "" ,fld_icexpire: "" ,fld_food: "" ,fld_tds: "" ,fld_mobile: "" ,fld_permitexpire: "" ,
    fld_drivelinexpire: "" ,fld_dieselappr: "" ,fld_remarks: "" ,fld_panno: "" ,fld_panaddress: "" ,fld_panname: "" , fld_favouring: "" , fld_HireModel : ""
 
   });

  const canEntry = hasPermission("Hire Vehicle Registration", "entry");

  const fetchVcode = async () => {
    try {
      Swal.fire({
        title: "Generating Vehicle Code",
        html: `
        <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div style="height: 10px; width: 0%; background: linear-gradient(to right, #43e97b, #38f9d7); animation: progressBar 2s linear infinite;"></div>
        </div>
        <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch a new vehicle code...</p>
      `,
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          const style = document.createElement("style");
          style.innerHTML = `
          @keyframes progressBar {
            0% { width: 0% }
            50% { width: 100% }
            100% { width: 0% }
          }
        `;
          document.head.appendChild(style);
        },
      });

      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/hire_vCode"); 
      if (response.data.priorPrNo) {
        const purchaseNo = parseInt(response.data.priorPrNo, 10) || 0;
        setVcode(purchaseNo.toString());
        setFormData(prevState => ({ ...prevState, newPurNo: purchaseNo.toString() }));
      }

      Swal.close();
    } catch (error) {
      Swal.close();
      console.error("Error fetching indent number:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Could not generate vehicle code. Please try again later.",
      });
    }
  };

  useEffect(() => {
    {canEntry && (
      fetchVcode()
    )}
  }, []);


  useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/get_branches")
      .then((response) => {
        setbranches(response.data.branches);
      })
      .catch((error) => {
        console.error("Error fetching branches:" ,error);
      });
  } ,[]);

  useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/get_vehicle_types")
      .then((response) => {
        setvehtypes(response.data.vehtypes);
        
        
      })
      .catch((error) => {
        console.error("Error fetching data:" ,error);
      });
  } ,[]);

  // ====== helpers for numeric / text validation ======
  const cleanNumber = (val) => {
    if (val == null) return "";
    // remove commas, currency symbol, spaces
    return String(val).replace(/[₹,\s]/g, "").trim();
  };

  const isValidMoney = (s) => {
    // allow integers or up to 2 decimals: 123 or 123.45
    return /^\d+(\.\d{1,2})?$/.test(s);
  };

  // only letters and spaces (for name-like fields)
  const isAlpha = (s) => /^[A-Za-z\s]+$/.test(String(s).trim());

  // vehicle number: letters, digits, spaces, dashes
  const isValidVehicleNo = (s) =>
    /^[A-Za-z0-9-\s]+$/.test(String(s).trim());

  // phone / mobile: digits with optional +, spaces, -, ()
  const isValidPhone = (s, minDigits = 5, maxDigits = 15) => {
    const str = String(s).trim();
    if (!/^[+\d\s\-()]+$/.test(str)) return false;
    const digits = (str.match(/\d/g) || []).length;
    return digits >= minDigits && digits <= maxDigits;
  };

  // Indian-style PAN (not mandatory to be perfect, but better than nothing)
  const isValidPAN = (s) =>
    /^[A-Z]{5}[0-9]{4}[A-Z]$/i.test(String(s).trim());

  const handleChange = (e) => {
    const { name ,value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const Fields = [
      { key: "newPurNo", label: "Purchase No" },
      { key: "fld_vehno", label: "Vehicle No" },
      { key: "fld_vname", label: "Vehicle Name" },
      { key: "fld_vtype", label: "Vehicle Type" },
      { key: "fld_vbasis", label: "Vehicle Basis" },
      { key: "fld_vcompanyname", label: "Company Name" },
      { key: "fld_ownersname", label: "Owner's Name" },
      { key: "fld_vprice", label: "Vehicle Price" },
      { key: "fld_contactperson", label: "Contact Person" },
      { key: "fld_address1", label: "Address Line 1" },
      { key: "fld_city", label: "City" },
      { key: "fld_phone", label: "Phone" },
      { key: "fld_vehappperiod", label: "Approved Period" },
      { key: "fld_fcexpire", label: "FC Expiry" },
      { key: "fld_icexpire", label: "Insurance Expiry" },
      { key: "fld_food", label: "Food (Y/N)" },
      { key: "fld_tds", label: "TDS" },
      { key: "fld_mobile", label: "Mobile" },
      { key: "fld_permitexpire", label: "Permit Expiry" },
      { key: "fld_dieselappr", label: "Diesel Approved" },
      { key: "fld_panno", label: "PAN Number" },
      { key: "fld_panaddress", label: "PAN Address" },
      { key: "fld_panname", label: "PAN Name" },
      { key: "fld_favouring", label: "Favouring" },
      { key: "fld_HireModel", label: "Hire Model" }
    ];
  
    // required check
    for (const field of Fields) {
      const value = formData[field.key];
      if (!value || value.toString().trim() === "") {
        Swal.fire({
          icon: "warning",
          title: "Missing Field",
          text: `Please enter ${field.label}`,
          width: "400px"
        });
        return;
      }
    }

    // ===== extra TYPE validations (numbers vs text) =====

    // vehicle number pattern
    if (!isValidVehicleNo(formData.fld_vehno)) {
      await Swal.fire({
        icon: "warning",
        title: "Invalid Vehicle Number",
        text: "Vehicle Number should contain only letters, numbers, spaces and dashes.",
        width: "420px",
      });
      return;
    }

    // name-like fields: alphabets & spaces only
    const alphaFields = [
      { key: "fld_vname", label: "Vehicle Name" },
      { key: "fld_vcompanyname", label: "Vehicle Company Name" },
      { key: "fld_ownersname", label: "Owner's Name" },
      { key: "fld_contactperson", label: "Contact Person" },
      { key: "fld_city", label: "City" },
      { key: "fld_panname", label: "PAN Holder Name" },
      { key: "fld_favouring", label: "Cheque Favouring Name" }
    ];

    for (const field of alphaFields) {
      const val = formData[field.key];
      if (val && !isAlpha(val)) {
        await Swal.fire({
          icon: "warning",
          title: `Invalid ${field.label}`,
          text: `${field.label} should contain only letters and spaces (no numbers or special characters).`,
          width: "450px",
        });
        return;
      }
    }

    // phone
    if (!isValidPhone(formData.fld_phone, 5, 15)) {
      await Swal.fire({
        icon: "warning",
        title: "Invalid Telephone",
        text: "Telephone should contain digits with optional +, spaces, -, ().",
        width: "430px",
      });
      return;
    }

    // mobile (usually at least 10 digits)
    if (!isValidPhone(formData.fld_mobile, 10, 15)) {
      await Swal.fire({
        icon: "warning",
        title: "Invalid Mobile Number",
        text: "Mobile number should contain 10–15 digits with optional +, spaces, -, ().",
        width: "430px",
      });
      return;
    }

    // PAN format
    if (!isValidPAN(formData.fld_panno)) {
      await Swal.fire({
        icon: "warning",
        title: "Invalid PAN Number",
        text: "PAN should be in format AAAAA9999A (10 characters).",
        width: "430px",
      });
      return;
    }

    // ===== existing price validation =====
    const priceRaw = cleanNumber(formData.fld_vprice);
    if (!isValidMoney(priceRaw)) {
      await Swal.fire({
        icon: "warning",
        title: "Invalid Price",
        text: "Vehicle Price must be a valid number (e.g., 12000 or 12000.50).",
        width: "420px",
      });
      return;
    }
    const price = Number(priceRaw); // guaranteed numeric now

  
    const payload = {
      fld_vcode: formData.newPurNo,
      fld_date: formData.fld_date,
      branch_code: formData.branch_code,
      fld_vehno: formData.fld_vehno,
      fld_vname: formData.fld_vname,
      fld_vtype: formData.fld_vtype,
      fld_vbasis: formData.fld_vbasis,
      fld_vcompanyname: formData.fld_vcompanyname,
      fld_ownersname: formData.fld_ownersname,
      fld_vprice: price,
      fld_contactperson: formData.fld_contactperson,
      fld_address1: formData.fld_address1,
      fld_address2: formData.fld_address2,
      fld_city: formData.fld_city,
      fld_phone: formData.fld_phone,
      fld_vehappperiod: formData.fld_vehappperiod,
      fld_fcexpire: formData.fld_fcexpire,
      fld_icexpire: formData.fld_icexpire,
      fld_food: formData.fld_food,
      fld_tds: formData.fld_tds,
      fld_mobile: formData.fld_mobile,
      fld_permitexpire: formData.fld_permitexpire,
      fld_drivelinexpire: formData.fld_drivelinexpire,
      fld_dieselappr: formData.fld_dieselappr,
      fld_remarks: formData.fld_remarks,
      fld_panno: formData.fld_panno,
      fld_panaddress: formData.fld_panaddress,
      fld_panname: formData.fld_panname,
      fld_favouring: formData.fld_favouring,
      fld_HireModel: formData.fld_HireModel
    };
  
    try {

      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
        
      const response = await axios.post(
        `https://rfs2.infraconsoft.net.in/api/add_hire_master_api/${selectedBranch}`,
        payload
      );
  
      Swal.fire({
        title: "Success!",
        text: "Inserted successfully.",
        icon: "success",
        width: "500px",
        height: "40vh",
        draggable: true
      }).then(() => {
        navigate("/hire_vehicle_registration_listing");
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Something went wrong. Please try again.",
        width: "400px"
      });
    }
  };

  if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
            <h2 className="add-txt">Add New Hire Vehicle</h2>
            <Link to='/hire_vehicle_registration_listing'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input
                  type="text"
                  name="newPurNo"
                  value={formData.newPurNo}
                  onChange={handleChange}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Vehicle Type:</label>
                <select name="fld_vtype"  value={formData.fld_vtype}   className="branch-select" onChange={handleChange} >
                  <option value="">-- Select Type -- </option>
                  {vehtypes.map((item) => (
                    <option key={item.fld_vehiclename} value={item.fld_vehiclename}>
                      {item.fld_vehiclename}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Register Number:</label>
                <input
                  type="text"
                  name="fld_vehno"
                  value={formData.fld_vehno}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Model:</label>
                <input
                  type="text"
                  name="fld_HireModel"
                  value={formData.fld_HireModel}
                  onChange={handleChange}
                />
              </div> 
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name:</label>
                <input
                  type="text"
                  name="fld_vname"
                  value={formData.fld_vname}
                  onChange={handleChange}
                />
              </div>    
              <div className="form-group"></div>           
            </div>
            <h3> Contact Info</h3>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Company name:</label>
                <input
                  type="text"
                  name="fld_vcompanyname"
                  value={formData.fld_vcompanyname}
                  onChange={handleChange}
                />
                
              </div>
              <div className="form-group">
                <label>Vehicle Basis:</label>
                <select  name="fld_vbasis"  value={formData.fld_vbasis}   className="branch-select" onChange={handleChange} >
                  <option value="">--- Select ---</option>
                  <option value="Hour">Hour</option>
                  <option value="Ton">Ton</option>
                  <option value="Kmhour">Kmhour</option>
                  <option value="Km">Km</option>
                  <option value="Month">Month</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Address Line 1:</label>
                <input
                  type="text"
                  name="fld_address1"
                  value={formData.fld_address1}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Address Line 2:</label>
                <input
                  type="text"
                  name="fld_address2"
                  value={formData.fld_address2}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Rent:</label>
                <input
                  type="text"
                  name="fld_vprice"
                  value={formData.fld_vprice}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Owner's Name:</label>
                <input
                  type="text"
                  name="fld_ownersname"
                  value={formData.fld_ownersname}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City:</label>
                <input
                  type="text"
                  name="fld_city"
                  value={formData.fld_city}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>TelePhone:</label>
                <input
                  type="text"
                  name="fld_phone"
                  value={formData.fld_phone}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Contact person:</label>
                <input
                  type="text"
                  name="fld_contactperson"
                  value={formData.fld_contactperson}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Vehicle Approval Date:</label>
                <input
                  type="date"
                  name="fld_vehappperiod"
                  value={formData.fld_vehappperiod}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Mobile no:</label>
                <input
                  type="text"
                  name="fld_mobile"
                  value={formData.fld_mobile}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>FC Expire:</label>
                <input
                  type="date"
                  name="fld_fcexpire"
                  value={formData.fld_fcexpire}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Permit Expire:</label>
                <input
                  type="date"
                  name="fld_permitexpire"
                  value={formData.fld_permitexpire}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>IC Expire:</label>
                <input
                  type="date"
                  name="fld_icexpire"
                  value={formData.fld_icexpire}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Food For Driver:</label>
                <select  name="fld_food"  value={formData.fld_food}   className="branch-select" onChange={handleChange} >
                  <option value="">--- Select ---</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div className="form-group">
                <label>TDS:</label>
                <select  name="fld_tds"  value={formData.fld_tds}   className="branch-select" onChange={handleChange} >
                  <option value="">--- Select ---</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Diesel:</label>
                <select  name="fld_dieselappr"  value={formData.fld_dieselappr}  className="branch-select" onChange={handleChange} >
                  <option value="">--- Select ---</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div className="form-group">
                <label>Cheque Favouring Name:</label>
                <input
                  type="text"
                  name="fld_favouring"
                  value={formData.fld_favouring}
                  onChange={handleChange}
                />
              </div>
            </div>
           
            <div className="form-row">
              <div className="form-group">
                <label>PAN Holder Name:</label>
                <input
                  type="text"
                  name="fld_panname"
                  value={formData.fld_panname}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>PAN Card no:</label>
                <input
                  type="text"
                  name="fld_panno"
                  value={formData.fld_panno}
                  onChange={handleChange}
                />
              </div>
            </div>
           
            <div className="form-row">
              <div className="form-group">
                <label>Mailing Address:</label>
                <input
                  type="text"
                  name="fld_panaddress"
                  value={formData.fld_panaddress}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Remarks:</label>
                <input
                  type="text"
                  name="fld_remarks"
                  value={formData.fld_remarks}
                  onChange={handleChange}
                />
              </div>
            </div>
           
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default AddHireVehicle;
